import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { BankDetailsService } from '../../../core/services/bank/bank-details/bank-details.service'
import { ContractStatusService } from '../../../core/services/contract/contract-status/contract-status.service'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import { MatOption, MatSelect } from '@angular/material/select'
import { ProfileService } from '../../../core/services/profile/profile.service'
import { UserManagementService } from '../../../core/services/user-management/user-management.service'

@Component({
  selector: 'driver-management-warn',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelect,
    MatOption,
  ],
  templateUrl: './driver-management-warn.component.html',
  styleUrl: './driver-management-warn.component.scss',
  providers: [LegalEntityClientService],
  standalone: true,
})
export class DriverManagementWarnComponent {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<DriverManagementWarnComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  @Output() responseEdit = new EventEmitter()
  isEditing: boolean = false
  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  profilesList: any[] = []
  close() {
    this.dialogRef.close()
  }
}
